import { makeAutoObservable, observable, runInAction } from "mobx";

export class PhoneEmailSupperationStore {
  phoneEmailMapper = observable.map({
    selectedType: "",
    selectedOptions: [],
    activeTab: "",
    noOfContact: 10,
    catchAllOption: "with",
  });

  constructor(rootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  // Getters
  get getActiveTab() {
    return this.phoneEmailMapper.get("activeTab") || null;
  }

  get getSelectedType() {
    return this.phoneEmailMapper.get("selectedType") || "";
  }

  get getSelectedOptions() {
    return this.phoneEmailMapper.get("selectedOptions") || [];
  }

  get getNoOfContact() {
    return this.phoneEmailMapper.get("noOfContact") || 10;
  }

  get getCatchAllOption() {
    return this.phoneEmailMapper.get("catchAllOption") || "with"; // Default "with"
  }

  // Setter
  applyTheValue(updates) {
    runInAction(() => {
      for (const [key, value] of Object.entries(updates)) {
        this.phoneEmailMapper.set(key, value);
      }
    });
  }

  // Clear all
  clearAll() {
    runInAction(() => {
      this.phoneEmailMapper.clear();
    });
  }
}
